import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class MiintoBrandMapApiClient extends AdvancedApiClient {

    static entityType = "MiintoBrandMap"

    constructor(token, brandId, id) {
        super();

        this.setEntityType(MiintoBrandMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/brand/{bid}/miinto-map/{id}")
                .setRouteParam("bid", brandId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/brand/{bid}/miinto-map")
                .setRouteParam("bid", brandId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}